/// <amd-module name="typeahead/client/UserAccountPageHandler" />

import {ClientHandlerRegistry, IClientHandler} from "typeahead/client/ClientHandlerRegistry";
import {GeolocationViewController} from "typeahead/core/geolocation/GeolocationViewController";

export class UserAccountPageHandler implements IClientHandler {
    private static readonly APPLICABLE_CLIENT_ID = "UserAccountPage";

    public isApplicable(clientId: string): boolean {
        return UserAccountPageHandler.APPLICABLE_CLIENT_ID === clientId;
    }

    public subscribeFormSubmitEvent(): void {
       // Not applicable
    }

    public subscribeFormLoadedEvent(): void {
        // Not applicable
    }

    public getTab(): string {
        // Not applicable
        return undefined;
    }

    public getGeolocationViewController(): GeolocationViewController {
        // Not applicable
        return undefined;
    }
}
